import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pageTitle" }
const _hoisted_3 = { class: "buttonsSelector" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "buttonsTitle" }, "Visualizza", -1)
const _hoisted_5 = { class: "buttons" }
const _hoisted_6 = { class: "midTitle" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "midTitle" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_13 = { class: "midTitle" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_15 = { class: "midTitle" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_18 = { class: "text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_dati_base_user = _resolveComponent("dati-base-user")!
  const _component_dati_lead = _resolveComponent("dati-lead")!
  const _component_dati_cliente = _resolveComponent("dati-cliente")!
  const _component_dati_collaboratore = _resolveComponent("dati-collaboratore")!

  return (_ctx.user)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            localizedKey: "Dettaglio Utenza:",
            text: "Dettaglio Utenza:"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.user.personalData.name) + " " + _toDisplayString(_ctx.user.personalData.surname), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'DatiBase' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAs = 'DatiBase'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dati base",
                text: "Dati base"
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'Lead' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showAs = 'Lead'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Lead",
                text: "Lead"
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'Cliente' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showAs = 'Cliente'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Cliente",
                text: "Cliente"
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["button", { selected: _ctx.showAs == 'Collaboratore' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showAs = 'Collaboratore'))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Collaboratore",
                text: "Collaboratore"
              })
            ], 2)
          ])
        ]),
        (_ctx.showAs == 'DatiBase')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati base",
                  text: "Dati base"
                })
              ]),
              _hoisted_7,
              _createVNode(_component_dati_base_user, {
                user: _ctx.user,
                roles: _ctx.rolesList,
                edit: true
              }, null, 8, ["user", "roles"]),
              (_ctx.user.role == 'CentroFumo' && _ctx.user.identifier)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("label", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Configurazione orari prenotazioni",
                        text: "Configurazione orari prenotazioni"
                      })
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        type: "button",
                        disabled: !_ctx.user.identifier,
                        class: "btn btn-warning",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openModalOrari && _ctx.openModalOrari(...args)))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Orari della settimana",
                          text: "Orari della settimana"
                        })
                      ], 8, _hoisted_8),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: !_ctx.user.identifier,
                        class: "ml-2 btn btn-warning",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openInclusioneOrari && _ctx.openInclusioneOrari(...args)))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Includi giorni",
                          text: "Includi giorni"
                        })
                      ], 8, _hoisted_9),
                      _createElementVNode("button", {
                        type: "button",
                        disabled: !_ctx.user.identifier,
                        class: "ml-2 btn btn-warning",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openEsclusioneOrari && _ctx.openEsclusioneOrari(...args)))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Escludi giorni",
                          text: "Escludi giorni"
                        })
                      ], 8, _hoisted_10)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showAs == 'Lead')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati lead",
                  text: "Dati lead"
                })
              ]),
              _hoisted_12,
              _createVNode(_component_dati_lead, { user: _ctx.user }, null, 8, ["user"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showAs == 'Cliente')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati cliente",
                  text: "Dati cliente"
                })
              ]),
              _hoisted_14,
              _createVNode(_component_dati_cliente, { user: _ctx.user }, null, 8, ["user"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.showAs == 'Collaboratore')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Dati collaboratore",
                  text: "Dati collaboratore"
                })
              ]),
              _hoisted_16,
              _createVNode(_component_dati_collaboratore, { user: _ctx.user }, null, 8, ["user"])
            ], 64))
          : _createCommentVNode("", true),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary mb-5",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Salva",
              text: "Salva"
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}